import { Box, Button, Stack } from "@mui/material";
import React, { forwardRef, useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import classes from "../DatosCliente.module.css";
import {
  UPDATE_DATOS_CLIENTE_STEP,
  useStepsContext,
} from "../../../../contexts/steps-controller";
import { DatosClienteValidationSchema } from "../../../../models/yupModels";
import Theme from "../../../../constants/Theme";
import { useFormik } from "formik";
import SelectorTipoPersona from "./sections/SelectorTipoPersona";
import FormaPagoCfdi from "./sections/FormaPagoCfdi";
import CPCalleColonia from "./sections/CPCalleColonia";
import NumeroCiudadEstado from "./sections/NumeroCiudadEstado";
import RazonSocial from "./sections/RazonSocial";
import { getRIFs, getcfdis } from "../../../../controllers/informacion";
import RfcRif from "./sections/RfcRif";

const FormDatosCliente = forwardRef(function FormDatosCliente(
  { nextStep, prevStep, showToast, isActive, ...props },
  ref
) {
  const { formStepsState, formStepsController } = useStepsContext();

  const [isDisabled, setIsDisabled] = useState(false);

  //Variables de RIF y CFDI
  const [cfdiSelected, setCfdiSelected] = useState("");
  const [rifSelected, setRifSelected] = useState("");
  const [rifs, setRifs] = useState([]);
  const [cfdis, setCfdis] = useState([]);

  const formik = useFormik({
    initialValues: formStepsState.datosClienteStep,
    validationSchema: DatosClienteValidationSchema,
    onSubmit: (props) => {
      //Pasar sig pantalla
      setIsDisabled(true);
      formStepsController({
        type: UPDATE_DATOS_CLIENTE_STEP,
        props,
      });
      setTimeout(() => {
        nextStep();
        setIsDisabled(false);
      }, 50);
    },
  });

  //Función para obtener los RIFS según el tipo de persona
  const _handleGetRIFs = (personaFisica) => {
    getRIFs(personaFisica)
      .then((rifs) => {
        setRifs(rifs);
      })
      .catch((message) => {
        showToast({
          type: "error",
          message,
          onClickCallback: _handleGetRIFs,
        });
      });
  };

  //Función para obtener los CFDI según el RIF
  const _handleGetCFDIs = (rif) => {
    getcfdis(rif)
      .then((cfdis) => {
        setCfdis(cfdis);
      })
      .catch((message) => {
        showToast({
          type: "error",
          message,
          onClickCallback: this._handleGetCFDIs,
        });
      });
  };

  //Detecta cuando se esta reiniciando el form, es decir está en la primer pantalla
  useEffect(() => {
    if (isActive === 1) {
      formik.resetForm();
      setCfdiSelected("");
      setRifSelected("");
    }
  }, [isActive]);

  //Cada que cambie el rif seleccioando, actualizamos el valor en el formulario y obtener los cfdi correspondientes
  useEffect(() => {
    const limpiarCfdi = async () => {
      await formik.setFieldValue("usoCFDI", "", true);
    };
    if (rifSelected && rifSelected !== "" && rifSelected !== 0) {
      formik.setFieldValue("RIF", rifSelected, true);
      limpiarCfdi();
      setCfdiSelected("");
      //Esperamos a que se actualice el estado
      setTimeout(() => {
        _handleGetCFDIs(rifSelected);
      }, 5);
    }
  }, [rifSelected]);

  //Cuando cambie la persona física hacemos la consulta de los rifs correspondientes
  useEffect(() => {
    //Función para reinciar el vaor del
    const limpiarRif = async () => {
      await formik.setFieldValue("RIF", "", true);
    };
    //Reiniciamos el valor del rif
    setRifSelected("");
    //Esperamos 5 ms para que se actualice el estado y hacer la petición
    setTimeout(() => {
      limpiarRif();
      _handleGetRIFs(formik.values.personaFisica);
    }, 5);
  }, [formik.values.personaFisica]);

  //Cuando cambia el cfdi seleccionado, actualizamos el valor del form
  useEffect(() => {
    if (cfdiSelected && cfdiSelected !== "") {
      formik.setFieldValue("usoCFDI", cfdiSelected, true);
    }
  }, [cfdiSelected]);

  return (
    <Box ref={ref} sx={{ display: "flex" }}>
      <Box sx={{ display: "flex", flexDirection: "column", p: 0 }}>
        <Box
          className={classes.formDatosCliente}
          sx={{
            display: "flex",
            justifyContent: "center",
            p: { xs: 2, sm: 0 },
            flex: "1 0",
            flexDirection: "column",
            borderRadius: 1,
          }}
        >
          <h2>Ingresa tus datos fiscales para continuar</h2>
          <SelectorTipoPersona formik={formik} />
          <RfcRif
            formik={formik}
            showToast={showToast}
            isActive={isActive}
            rifs={rifs}
            setRifSelected={setRifSelected}
            rifSelected={rifSelected}
          />
          <RazonSocial formik={formik} />
          <FormaPagoCfdi
            formik={formik}
            showToast={showToast}
            cfdis={cfdis}
            setCfdiSelected={setCfdiSelected}
            cfdiSelected={cfdiSelected}
            isActive={isActive}
          />
          <CPCalleColonia showToast={showToast} formik={formik} />
          <NumeroCiudadEstado formik={formik} />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Button
              onClick={() => {
                setTimeout(() => {
                  prevStep();
                }, 300);
              }}
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              className={classes.backButton}
              style={{ color: Theme.COLORS.LIGHT_GRAY }}
            >
              Volver
            </Button>
            <Button
              variant="contained"
              className="buttonNext"
              disabled={isDisabled}
              onClick={() => formik.handleSubmit()}
              style={{
                backgroundColor: !isDisabled
                  ? Theme.COLORS.PRIMARY
                  : Theme.COLORS.LIGHT_GRAY,
                  fontFamily: 'Montserrat, Arial, sans-serif'
              }}
            >
              {!isDisabled ? "Siguiente paso" : "Cargando"}
            </Button>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
});

export default FormDatosCliente;
